// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const appPublicationGQLFields = (fields) => {
    return `
    id
    addedById
    itemId
    networkId
    createdAt
  `;
};
//# sourceMappingURL=appPublication.fields.js.map